import "./App.css";
import Navigation from "./components/Navigation/Navigation";
import Body from "./components/Body/Body";

function App() {
  return (
    <div className="App">
      <Navigation />
      <Body />
    </div>
  );
}

export default App;
